module.exports = __webpack_public_path__ + "static/img/envelope-bg.2e1f279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-sign-in/envelope-bg.png
// module id = S3RF
// module chunks = 215